export default __webpack_public_path__ + "static/media/Instgram.d158cc38.svg";